import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SettingService } from '../setting/setting.service';

@Component({
  selector: 'app-user-in-forms',
  templateUrl: './user-in-forms.component.html',
  styleUrls: ['./user-in-forms.component.scss']
})
export class UserInFormsComponent implements OnInit {
  userId:any;
  formId:any;
  userForms:any
  isLoading:boolean = false;
  panelOpenState = false;
  filterByUserType = ""
  searchEmail = "";
  constructor(private route:ActivatedRoute,private adminService:SettingService,private router:Router) { }
  from = "";
  circleId = "";
  userData = ""
  ngOnInit() {
    this.userData = JSON.parse(localStorage.getItem("userData")) || "noemail";
    this.route.queryParams.subscribe((param) => {
      this.formId = param["formId"];
      this.from = param['from'];
      this.userId = param['userId'];
      this.circleId = param['circleId']
      if(param) {
        this.getUserRespondedForms();
      }
    });
  }

  getUserRespondedForms() {
    this.isLoading = true;
    let query = "";
    query = this.queryParams()
    this.adminService.getUsersFormList(query).subscribe (
      res => {
      this.isLoading = false;
      if ((res["message"] == "Success")) {
       this.userForms = res.data.usersList;
      } else {
        this.userForms = [];
      }      },
      err => {
      this.isLoading = false;
      }
    );
  }

  queryParams() {
    let query = ""
    query ="formId="+this.formId;
    // let query = "&limit=" + this.pagelimit + "&offset=" + this.pagelimit * this.currentPage;;
    if (this.searchEmail && this.searchEmail !== "") {
      query = query + "&email=" + this.searchEmail.toLowerCase().trim();
    }
    
    if (this.filterByUserType) {
      query = query + "&userType=" + this.filterByUserType;
    }
    
    
    

    return query;
  }

  resetFilter() {
    
    this.filterByUserType = ""
    this.searchEmail = ""
    this.getUserRespondedForms();

  }

  onFilterChange() {
    this.getUserRespondedForms();
  }


  readLocalStorageValue(key: string): string {
    return localStorage.getItem(key);
  }

  navigateBAck () {
    if(this.from == "circle") {
      this.router.navigate(["/main/circles/circle-profile/circle-members"],{ queryParams: { ownerId:this.userId,id:this.circleId,from:this.from}, preserveQueryParams: false });
    } else {
      this.router.navigate(["/main/setting/manage-forum/viewForum"]);
    }
    }

  
    navigateToFormPage (item) {
      if(item.userType == 'External') {
        this.router.navigate(["/main/user-response-form-view"],{ queryParams: { userId:this.userId,from:this.from,formId:item.formId,n:item.userName,circleId:this.circleId,formResponseId:item.formResponseId}, preserveQueryParams: false });
      }
           else {
            this.router.navigate(["/main/user-response-form-view"],{ queryParams: { userId:item.userId,from:this.from,formId:item.formId,n:item.userName,circleId:this.circleId,formResponseId:""}, preserveQueryParams: false });
           }
    }

}










